import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import {ReportModule} from './modules/report/report.module';
import {AuthAdminGuard} from './core/auth/guards/authAdmin.guard';
import {
    BudgetPrevisionSimulationsModule
} from "./modules/budget-prevision-simulations/budget-prevision-simulations.module";
import {CondominiumGuard} from "./core/auth/guards/condominium.guard";

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed in user to the '/example'
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'condominios' },

    // Auth routes (guest)
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'user-password', loadChildren: () => import('app/modules/auth/user-password/user-password.module').then(m => m.AuthUserPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule) },
        ]
    },

    // Auth routes (guest)
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'aprovacao-ata', loadChildren: () => import('app/modules/assembly/protocol-approve/protocol-approve.module').then(m => m.ProtocolApproveModule) },
            { path: 'download', loadChildren: () => import('app/modules/download/download.module').then(m => m.DownloadModule) },
        ]
    },

    // Admin routes
    {
        path: 'admin',
        canActivate: [AuthAdminGuard],
        component: LayoutComponent,
        data: {
            layout: 'admin'
        },
        resolve: {
            initialData: InitialDataResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/admin/admin.module').then(m => m.AdminModule) },
            { path: 'cartao-credito', data: {title: 'Emissão de cartão de crédito'}, loadChildren: () => import('app/modules/credit-card/credit-card.module').then(m => m.CreditCardModule) },
            { path: 'identificacao-deposito', data: {title: 'Identificação de Depósito'}, loadChildren: () => import('app/modules/deposit-identification/deposit-identification.module').then(m => m.DepositIdentificationModule) },
            { path: 'assembleias', data: {title: 'Assembléias'}, loadChildren: () => import('app/modules/assembly/assembly.module').then(m => m.AssemblyModule) },
            { path: 'simulador-previsao-orcamentaria', data: {title: 'Simulador de Previsão Orçamentária'}, loadChildren: () => import('app/modules/budget-prevision-simulations/budget-prevision-simulations.module').then(m => m.BudgetPrevisionSimulationsModule) },
            { path: 'pasta-digital', data: {title: 'Pasta Digital'}, loadChildren: () => import('app/modules/admin-folder/admin-folder.module').then(m => m.AdminFolderModule) },
            { path: 'bot-maria', data: {title: 'Bot Maria'}, loadChildren: () => import('app/modules/bot-maria/bot-maria.module').then(m => m.BotMariaModule) },
            { path: 'ficha-condominio', data: {title: 'Ficha do Condominio'}, loadChildren: () => import('app/modules/condominium-record/condominium-record.module').then(m => m.CondominiumRecordModule) },
        ]
    },

    // Admin routes
    {
        path: 'admin',
        canActivate: [AuthAdminGuard],
        component: LayoutComponent,
        data: {
            layout: 'admin'
        },
        resolve: {
            initialData: InitialDataResolver
        },
        children: [
            /*{ path: '', loadChildren: () => import('app/modules/admin/admin.module').then(m => m.AdminModule) },
            { path: 'cartao-credito', data: {title: 'Emissão de cartão de crédito'}, loadChildren: () => import('app/modules/credit-card/credit-card.module').then(m => m.CreditCardModule) },
            { path: 'identificacao-deposito', data: {title: 'Identificação de Depósito'}, loadChildren: () => import('app/modules/deposit-identification/deposit-identification.module').then(m => m.DepositIdentificationModule) },
            { path: 'assembleias', data: {title: 'Assembléias'}, loadChildren: () => import('app/modules/assembly/assembly.module').then(m => m.AssemblyModule) },*/
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard, CondominiumGuard],
        canActivateChild: [AuthGuard, CondominiumGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [

            { path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'condominios', data: {title: 'Condominios'}, loadChildren: () => import('app/modules/condominium/condominium.module').then(m => m.CondominiumModule) },
            { path: 'envio-de-contas-old', data: {title: 'Envio de Contas'}, loadChildren: () => import('app/modules/send-document/send-document.module').then(m => m.SendDocumentModule) },
            { path: 'envio-de-contas', data: {title: 'Envio de Contas'}, loadChildren: () => import('app/modules/send-bills/send-bills.module').then(m => m.SendBillsModule) },
            { path: 'devedores', data: {title: 'Devedores'}, loadChildren: () => import('app/modules/debtor/debtor.module').then(m => m.DebtorModule) },
            { path: 'extrato', data: {title: 'Extrato'}, loadChildren: () => import('app/modules/statement/statement.module').then(m => m.StatementModule) },
            { path: 'gerenciar-acesso', loadChildren: () => import('app/modules/functionalities/functionalities.module').then(m => m.FunctionalitiesModule) },
            { path: 'contracheque', data: {title: 'Contracheques'}, loadChildren: () => import('app/modules/paycheck/paycheck.module').then(m => m.PayCheckModule) },
            { path: 'beneficio', loadChildren: () => import('app/modules/benefits/benefits.module').then(m => m.BenefitsModule) },
            { path: 'colaborador', data: {title: 'Colaboradores'}, loadChildren: () => import('app/modules/collaborator/collaborator.module').then(m => m.CollaboratorModule) },
            { path: 'boletos', data: {title: 'Boletos'}, loadChildren: () => import('app/modules/boleto/boleto.module').then(m => m.BoletoModule) },
            { path: 'acordos', data: {title: 'Acordos'}, loadChildren: () => import('app/modules/agreements/agreements.module').then(m => m.AgreementsModule) },
            { path: 'balancete', data: {title: 'Balancete'}, loadChildren: () => import('app/modules/balance/balance.module').then(m => m.BalanceModule) },
            { path: 'servicos', data: {title: 'Serviços CIPA'}, loadChildren: () => import('app/modules/services/services.module').then(m => m.ServicesModule) },
            { path: 'gestao-documento', data: {title: 'Gestão de Documentos'}, loadChildren: () => import('app/modules/document-manager/document-manager.module').then(m => m.DocumentManagerModule) },
            { path: 'encomendas', data: {title: 'Encomendas'}, loadChildren: () => import('app/modules/package/package.module').then(m => m.PackageModule) },
            { path: 'unidades', data: {title: 'Unidades'}, loadChildren: () => import('app/modules/unit/unit.module').then(m => m.UnitModule) },
            { path: 'enviar-ideia', data: {title: 'Enviar ideia'}, loadChildren: () => import('app/modules/send-idea/send-idea.module').then(m => m.SendIdeaModule) },
            { path: 'pasta-digital', data: {title: 'Pasta Digital'}, loadChildren: () => import('app/modules/folder/folder.module').then(m => m.FolderModule) },
            { path: 'contas-a-pagar', data: {title: 'Contas a Pagar'}, loadChildren: () => import('app/modules/unpaid-bill/unpaid-bill.module').then(m => m.UnpaidBillModule) },
            { path: 'configuracoes', data: {title: 'Configurações'}, loadChildren: () => import('app/modules/settings/settings.module').then(m => m.SettingsModule) },
            { path: 'mural-de-avisos', data: {title: 'Mural de Avisos'}, loadChildren: () => import('app/modules/notice-board/notice-board.module').then(m => m.NoticeBoardModule) },
            { path: 'orcado-realizado', data: {title: 'Orçado x Realizado'}, loadChildren: () => import('app/modules/estimated-fulfilled/estimated-fulfilled.module').then(m => m.EstimatedFulfilledModule) },
            { path: 'manad', data: {title: 'Manad'}, loadChildren: () => import('app/modules/manad/manad.module').then(m => m.ManadModule) },
            { path: 'reserva-de-espaco', data: {title: 'Reserva de Espaço'}, loadChildren: () => import('app/modules/space-reservation/space-reservation.module').then(m => m.SpaceReservationModule) },
            { path: 'engelink', data: {title: 'Compras online'}, loadChildren: () => import('app/modules/purchases/purchases.module').then(m => m.PurchasesModule) },
            { path: 'enquete', data: {title: 'Enquete'}, loadChildren: () => import('app/modules/survey/survey.module').then(m => m.SurveyModule) },
            { path: 'notificar-assessor', data: {title: 'Notificar Assessor'}, loadChildren: () => import('app/modules/notify-advisor/notify-advisor.module').then(m => m.NotifyAdvisorModule) },
            { path: 'atividades', data: {title: 'Atividades'}, loadChildren: () => import('app/modules/activity/activity.module').then(m => m.ActivityModule) },
            { path: 'estoque', data: {title: 'Estoque'}, loadChildren: () => import('app/modules/inventory/inventory.module').then(m => m.InventoryModule) },
            { path: 'gestao-de-cadastros', data: {title: 'Gestão de Cadastros'}, loadChildren: () => import('app/modules/registration-management/registration-management.module').then(m => m.RegistrationManagementModule) },
            { path: 'relatorios', data: {title: 'Relatórios'}, loadChildren: () => import('app/modules/report/report.module').then(m => m.ReportModule) },
            { path: 'saad', data: {title: 'Saad Advogados'}, loadChildren: () => import('app/modules/saad/saad.module').then(m => m.SaadModule) },
            { path: 'clube-vantagens', data: {title: 'Clube de Vantagens'}, loadChildren: () => import('app/modules/benefit-club/benefit-club.module').then(m => m.BenefitClubModule) },
            { path: 'gestao-assembleia', data: {title: 'Área Síndico'}, loadChildren: () => import('app/modules/area-sindico/area-sindico.module').then(m => m.AreaSindicoModule) },

            { path: 'error', loadChildren: () => import('app/modules/errors/errors.module').then(m => m.ErrorsModule) },

            // 404 & Catch all
            // {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/errors/error-404/error-404.module').then(m => m.Error404Module)},
            {path: '**', redirectTo: 'error/404'}
        ]
    },
];
